import Shapes from './Shapes'
import about from '../icons/about.png';

const Bio = () => {
  return (
    <section id="bio" className="hero-section" aria-label="About Samir Felfel">
      <Shapes />
      <div className="container">
        <div className="hero-text">
          <div className="left-side">
            <h1 className='mt-2'>
              <img height={60} width={60} src={about} alt="About icon" /> About Me
            </h1>
            <hr />

            <p>
              Results-driven <strong>Software Engineer</strong> and <strong>Technical Consultant</strong> experience in
              enterprise application development and <strong>core banking system integration</strong>, specializing in <strong>Java, Spring Boot, SQL,</strong> and
              <strong> iMAL (Islamic Banking Platform)</strong>.
            </p>

            <p>
              Currently working at <strong>Azentio Software</strong>, I lead and contribute to the successful delivery of mission-critical banking <strong> (Full Implementation)</strong>
              solutions for regional banks across the <strong>UAE, Ethiopia, Iraq, Sri Lanka, and Egypt</strong>. My focus includes file-based integrations,
              real-time transaction automation, alerts, payroll modules, and third-party API integration, delivering scalable solutions that
              enhance operational efficiency.
            </p>

            <p>
              I bring hands-on engineering experience from <strong>Elsewedy Electric</strong>, where I built microservices and enterprise-grade web
              applications using <strong>Spring Boot, React.js, Docker,</strong> and <strong>SQL Server</strong>, optimizing production workflows and audit systems.
            </p>


            <p>
              Holding a <strong>BSc in Computer Science (First Class Honours)</strong> from <strong>London South Bank University</strong> and <strong>The British University in Egypt</strong>,
              I’m passionate about building intelligent, maintainable systems that empower users and stakeholders.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Bio